import * as React from "react";

import { getRoutePath, redirectToRoutePath, sectionClasses } from "../common/Utils";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";
import { WizardStep } from "../common/WizardStep";

import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";

import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";

declare var vehicleYears: Array<number>; // Global array with initial array of years
declare var awl: any;

interface IVehicleYearStepProps extends IStepProps {
    setVehicleMakes(vehicleMakes: string[]): void;
}

export class VehicleYearStep extends React.Component<IVehicleYearStepProps, IStepState> {

    state: IStepState;

    constructor(props: IVehicleYearStepProps)
    {
        super(props);

        this.handleOnClickVehicleYear = this.handleOnClickVehicleYear.bind(this);
        this.handleOnChangeSelectVehicleYear = this.handleOnChangeSelectVehicleYear.bind(this);
        this.handleSuccessfulRequest = this.handleSuccessfulRequest.bind(this);

        this.state = {
            redirectPath: "",
            goToNextStep: false
        }
    }

    nextStep(vehicleYear: string): void {
        
        let request = new XMLHttpRequest();
        let yearArgument: string = "&year=" + vehicleYear;
        
        if (!awl.autoWizard.ajaxVehicleMakesUrl.includes("?")) {
            yearArgument = "?year=" + vehicleYear;
        }

        const handleSuccessfulRequest = this.handleSuccessfulRequest;

        request.open('GET', awl.autoWizard.ajaxVehicleMakesUrl + yearArgument, true);

        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

        request.withCredentials = true;

        request.onreadystatechange = function() {
            if (this.readyState === 4) {
                if (this.status >= 200 && this.status < 400) {
                    // Success!
                    let data: string[] = JSON.parse(this.responseText);

                    handleSuccessfulRequest(vehicleYear, data);

                } else {
                    // Error :(
                }
            }
        };

        request.send();
        request = null;
    }

    handleSuccessfulRequest(vehicleYear: string, data: string[]): void {
        this.props.setVehicleMakes(data);

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.primaryVehicle.year = vehicleYear;

        this.props.onUpdateModel(model);

        const routePath = getRoutePath(WizardStep.PRIMARY_VEHICLE_MAKE);

        this.setState({ redirectPath: routePath, goToNextStep: true });
    }

    handleOnClickVehicleYear(event: React.MouseEvent<HTMLAnchorElement>): void {
        let valueElement = event.target as HTMLAnchorElement;
        let value = valueElement.dataset["value"];

        this.clearVehicleYearSelect();
        this.nextStep(value);
    }

    handleOnChangeSelectVehicleYear(event: React.FormEvent<HTMLSelectElement>): void {
        let valueElement = event.target as HTMLSelectElement;
        let value = valueElement.value;

        this.nextStep(value);
    }

    clearVehicleYearSelect(): void {
        let valueElement = document.getElementById("vehicleYearSelection")as HTMLSelectElement;
        valueElement.value = "";
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        const YEARS_TOUCH_LIST_SIZE = 24;
        let vehicleYearsTouchOptions: any[] = [];
        let vehicleYearsSelectOptions: any[] = [];

        for (var i = 0; i < YEARS_TOUCH_LIST_SIZE; i++) {
            let vehicleTouchOptionId = "vehicleYear_" + vehicleYears[i];
            let touchOptionClasses = "touch-list-option";
            let linkOptionClasses = this.props.model.primaryVehicle.year &&
                parseInt(this.props.model.primaryVehicle.year) === vehicleYears[i]
                ? " selected"
                : "";

            vehicleYearsTouchOptions.push(<div key={vehicleTouchOptionId} className={touchOptionClasses}><a className={linkOptionClasses} data-value={vehicleYears[i]} id={vehicleTouchOptionId} onClick={this.handleOnClickVehicleYear}>{vehicleYears[i]}</a></div>)
        }

        for (var j = YEARS_TOUCH_LIST_SIZE; j < vehicleYears.length; j++) {
            let vehicleYearsSelectOptionId = "vehicleYearOption_" + vehicleYears[j];
            vehicleYearsSelectOptions.push(<option key={vehicleYearsSelectOptionId} value={vehicleYears[j]}>{vehicleYears[j]}</option>);
        }

        const sectionStyle = {
            display: 'block'
        }

        return <React.Fragment>
            <LogStep lastStep="LAUNCH" nextStep="VehicleMake" stepNumber={QuoteFormEventType.VehicleYearStep} sectionName="VehicleYear" wizardName="AutoWizard" logStep={true}/>
            <div id="VehicleYearStep" className={sectionClasses} style={sectionStyle}>
               <h3>Select Your Vehicle Year:</h3>
               <div id="VehicleYear">
                   <div className="touch-list fourColumn" >
                       {vehicleYearsTouchOptions}
                   </div>
                   <select className="dropdown-list" id="vehicleYearSelection" onChange={this.handleOnChangeSelectVehicleYear}>
                       <option value="">Select a previous year</option>
                       {vehicleYearsSelectOptions}
                   </select>
               </div>
            </div>

            <div className="bottom-page-carrier-logos layout-section form-section">
                <h2>Providers include:</h2>
                {awl.autoWizard.CarrierLogoSrcUrls.map((value: string, index: number): JSX.Element => <img key={value} src={value} />)}
            </div>
        </React.Fragment>;
    }
};